// @ts-nocheck
import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import * as React from "react";
import ProductStatus from "@store/Library/Components/ProductStatus/ProductStatus";

type Props = WidgetProps & HasProduct;

export interface ProductDetailsProductStatusStyles {
    container?: GridContainerProps;
}

export const productStatusStyles: ProductDetailsProductStatusStyles = {
    container: {
        gap: 0,
    },
};

const styles = productStatusStyles;

const ProductDetailsProductStatus: React.FC<Props> = ({ product }) => {
    if (!product) {
        return null;
    }

    return (
        <GridContainer {...styles.container}>
            <ProductStatus product={product} isPdp={true} />
        </GridContainer>
    );
};

const widgetModule: WidgetModule = {
    component: withProduct(ProductDetailsProductStatus),
    definition: {
        displayName: "Product Status",
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
    },
};

export default widgetModule;
